
export default function featuredInsights () {

	const swipers = document.querySelectorAll('section.featured-insights .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');

		if (section.getAttribute('data-layout') == 'tiles') {

			new Swiper (container, {
				loop: false,
				snapToSlideEdge: true,
				breakpoints: {
					0:    { slidesPerView: 1.3, spaceBetween: 24 },
					600:  { slidesPerView: 2, spaceBetween: 36 },
					1024: { slidesPerView: 3, spaceBetween: 36 },
					1360: { slidesPerView: 4, spaceBetween: 48 },
				},
				pagination: {
					el: section.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: section.querySelector('.swipe-prev'),
					nextEl: section.querySelector('.swipe-next'),
				},
			});

		} else {

			new Swiper (container, {
				loop: false,
				spaceBetween: 36,
				slidesPerView: 1,
				pagination: {
					el: section.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: section.querySelector('.swipe-prev'),
					nextEl: section.querySelector('.swipe-next'),
				},
			});

		}

	});

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too. ACF's block-preview JS runs in the outer
	admin window, while this script runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=featured-insights', featuredInsights);
}
